import { useMemo } from 'react';
import styled from 'styled-components';
import {
	AttachmentBlockRuntime,
	buildAccountBlockRuntime,
	buildCardPaymentBlockPublic,
	buildSubscriptionBlockRuntime,
	ButtonBlockRuntime,
	CalendarBlockRuntime,
	ConditionalColumnsBlockRuntime,
	ConditionalImageBlockRuntime,
	ConditionalRichTextBlockRuntime,
	ConditionalSwiftPredictBlockRuntime,
	CreatePeopleBlockRuntime,
	CreatePersonBlockRuntime,
	DividerBlockRuntime,
	DropPanelBlockRuntime,
	EventLocationMapBlockRuntime,
	FormBlockRunTime,
	FormDropPanelBlockRunTime,
	LocationMapBlockRuntime,
	PointsBlockRunTime,
	QuestionBlockRuntime,
	RSVPBlockRuntime,
	RSVPNoBlockRuntime,
	RSVPYesBlockRuntime,
	SectionBlockRunTime,
	SectionDropPanelBlockRunTime,
	SurveyButtonNextBlockRuntime,
	SurveyButtonPreviousBlockRuntime,
	SurveyButtonSubmitBlockRuntime,
	TicketBlockRuntime,
	TransactionBlockRuntime,
	UploadFilesBlockRuntime,
	URLRedirectBlockRuntime,
	VideoBlockRuntime
} from '../blocks';
import { CountdownTimer } from '../count-down-timer/count-down-timer';
import { EventCapacityStatus, useFormEventContext } from '../form-event-context';
import { QuestionStyleTypes, SurveyState, useFormRuntimeContext, useQuestionStyle } from '../form-runtime-context';
import { RenderBlockComponent } from '../render-block-component';
import { BlockComponentContextProvider } from './block-component-context';

const FormWrapper = styled.div<{ $backgroundColour: string; $minHeight?: React.CSSProperties['minHeight'] | null }>`
	${props => (props.$minHeight ? `min-height:${props.$minHeight};` : '')}
	height: 100%;
	background-color: ${props => props.$backgroundColour};
	container-type: inline-size;
	max-width: 960px;
	margin: 0 auto;
	width: 100%;
	padding: 1rem;
`;

export function FormRuntime({ token }: { token?: string }) {
	const blocks = useMemo(
		() => [
			SurveyButtonNextBlockRuntime,
			SurveyButtonPreviousBlockRuntime,
			SurveyButtonSubmitBlockRuntime,
			RSVPBlockRuntime,
			RSVPYesBlockRuntime,
			RSVPNoBlockRuntime,
			LocationMapBlockRuntime,
			EventLocationMapBlockRuntime,
			CalendarBlockRuntime,
			buildSubscriptionBlockRuntime(token),
			buildCardPaymentBlockPublic(token),
			buildAccountBlockRuntime(token),
			TransactionBlockRuntime,
			TicketBlockRuntime,
			ConditionalSwiftPredictBlockRuntime,
			ConditionalRichTextBlockRuntime,
			ButtonBlockRuntime,
			ConditionalImageBlockRuntime,
			VideoBlockRuntime,
			AttachmentBlockRuntime,
			DividerBlockRuntime,
			FormBlockRunTime,
			SectionBlockRunTime,
			QuestionBlockRuntime,
			CreatePeopleBlockRuntime,
			CreatePersonBlockRuntime,
			UploadFilesBlockRuntime,
			ConditionalColumnsBlockRuntime,
			SectionDropPanelBlockRunTime,
			FormDropPanelBlockRunTime,
			URLRedirectBlockRuntime,
			PointsBlockRunTime,
			DropPanelBlockRuntime
		],
		[token]
	);
	const { event, waitlistSubmitted } = useFormEventContext();
	const { surveyState, layout } = useFormRuntimeContext();
	const { backgroundColour, minHeight } = useQuestionStyle(QuestionStyleTypes.general, {}) ?? {};

	if (!layout.layouts?.length) return <></>;
	return (
		<BlockComponentContextProvider formBlocks={blocks}>
			<FormWrapper $backgroundColour={backgroundColour ?? 'white'} $minHeight={minHeight}>
				{!event?.ticketsEnabled ? (
					surveyState !== SurveyState.submitted &&
					!waitlistSubmitted &&
					(event?.status === EventCapacityStatus.Available || event?.status === EventCapacityStatus.OnWaitlist) ? (
						<CountdownTimer loading={!token} />
					) : null
				) : null}
				{layout.layouts.map(layout => {
					return <RenderBlockComponent {...layout} key={layout.id} />;
				})}
			</FormWrapper>
		</BlockComponentContextProvider>
	);
}
